"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteCellFactory = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const autocomplete_1 = require("../../autocomplete/autocomplete");
function useAutocompleteCellFactory({ dataHook, multiple = false, }) {
    return react_1.useMemo(() => function AutocompleteCell({ value }) {
        const source = dataHook();
        return (react_1.default.createElement(autocomplete_1.Autocomplete, { disabled: true, source: source, value: value, onChange: lodash_1.noop, multiple: multiple }));
    }, [dataHook, multiple]);
}
exports.useAutocompleteCellFactory = useAutocompleteCellFactory;
//# sourceMappingURL=autocomplete-cell.js.map